import React, { useEffect, useState } from "react";
import * as Constants from "../../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../../loader/CircleLoade";
import { Link } from "react-router-dom";
import Navbar from "../../../common/Navbar";

export default function RetailerDashboard() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [faqsurl, setFaqsurl] = useState("");
  const [tncurl, setTncurl] = useState("");
  const [schemeurl, setSchemeurl] = useState("");
  const [rewardurl, setRewardurl] = useState("");
  const [evgurl, setEvgurl] = useState("");
  const [dashboardData, setDashboardData] = useState({});
  const [checkPopUp, setCheckPopUp] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showRedemptionPopup, setShowRedemptionPopup] = useState(false);
  const [showRewardMatrixPopup, setShowRewardMatrixPopup] = useState(false);
  const [showSchemePopup, setShowSchemePopup] = useState(false);
  const [showTdsModal, setShowTdsModal] = useState(false);
  const [tdsSelectedOption, setTdsSelectedOption] = useState("YES");
  const [submittingTds, setSubmittingTds] = useState(false);

  const [getPointsData, setGetPointsData] = useState({
    points: "",
    newPoints: "",
    redeemedPoints: "",
    newRedeemedPoints: "",
    tds: "",
    newTotalPoints: "",
  });

  useEffect(() => {
    getUserDetails();
    getDashboardData();
    getFaqsData();
    getEVGUrl();
    checkTdsConsentStatus();
  }, []);

  const checkTdsConsentStatus = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const res = await axios.get(
        `${Constants.baseUrl}user/tds-consent/status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program2,
          },
        }
      );
      const dt = res.data;
      if (dt?.result === "success" && dt?.output?.tdsConsent === false) {
        setShowTdsModal(true);
      }
    } catch (err) {
      console.log("Error checking TDS consent status", err);
    }
  };

  const handleTdsSubmit = async () => {
    const token = localStorage.getItem("token");
    setSubmittingTds(true);
    try {
      const res = await axios.post(
        `${Constants.baseUrl}user/tds-consent`,
        {
          selectedOption: tdsSelectedOption,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program2,
          },
        }
      );
      const dt = res.data;
      if (dt?.result === "success" || res.status === 200) {
        swal({
          text: dt?.msg || "TDS consent submitted successfully",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setShowTdsModal(false);
      } else {
        swal({
          text: dt?.msg || "Failed to submit TDS consent",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      }
    } catch (err) {
      console.log("Error submitting TDS consent", err);
      swal({
        text: err?.response?.data?.msg || "Something went wrong",
        icon: "error",
        timer: 2000,
        buttons: false,
      });
      setShowTdsModal(false);
    } finally {
      setSubmittingTds(false);
    }
  };


  const getDashboardData = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .get(`${Constants.baseUrl}purchase/purchaseHistory/retailer`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program2,
          },
        })
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setDashboardData(dt?.output);
          }
          if (dt.result === "error" || dt.result === "dialog") {
            setDashboardData({});
          }
        })
        .catch((err) => { });
    }
  };

  const getFaqsData = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .get(`${Constants.baseUrl}program/child/2`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            // appVersion: Constants.av,
            // platform: Constants.pt,
            // company: Constants.company,
            // program: Constants.program,
          },
        })
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setFaqsurl(dt?.output?.faqs);
            setTncurl(dt?.output?.tnc);
            setSchemeurl(dt?.output?.catelog);
            setRewardurl(dt?.output?.manual);
          }
        })
        .catch((err) => { });
    }
  };

  const getEVGUrl = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .post(
          `${Constants.baseUrl}web/evg/view_url`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          },
        )
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setEvgurl(dt?.output?.url);
          }
        })
        .catch((err) => { });
    }
  };

  const getUserDetails = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        Constants.baseUrl + "auth/profile/get",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        },
      );
      if (res?.data?.output) {
        const data = res.data.output;

        setGetPointsData({
          points: data.points ?? 0,
          newPoints: data.newPoints ?? 0,
          redeemedPoints: data.redeemedPoints ?? 0,
          newRedeemedPoints: data.newRedeemedPoints ?? 0,
          tds: data.tds ?? 0,
          newTotalPoints: data.newTotalPoints ?? 0,
        });
      }
      if (res.data.output?.upiStop === true) {
        setCheckPopUp(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpiRedemptionClick = (e) => {
    if (checkPopUp) {
      e.preventDefault();
      setShowPopup(true);
    }
    // If checkPopUp is false, allow normal navigation
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleRedemptionClick = (e) => {
    setShowRedemptionPopup(true);
  };

  const closeRedemptionPopup = () => {
    setShowRedemptionPopup(false);
  };


  const handleRewardMatrixClick = (e) => {
    e.preventDefault();
    setShowRewardMatrixPopup(true);
  };

  const closeRewardMatrixPopup = () => {
    setShowRewardMatrixPopup(false);
  };

  const handleSchemeClick = (e) => {
    e.preventDefault();
    setShowSchemePopup(true);
  };

  const closeSchemePopup = () => {
    setShowSchemePopup(false);
  };

  const summaryItems = [
    {
      label: "Redeemable Points",
      value: Number(getPointsData?.points + getPointsData?.newPoints),
      prefix: "",
    },
    {
      label: "Redeemed Points",
      value: Number(
        getPointsData?.redeemedPoints + getPointsData?.newRedeemedPoints,
      ),
      prefix: "",
    },
    {
      label: "Old Points",
      value: Number(getPointsData?.points),
      prefix: "",
      pointOne: "Earned on/before 31-Oct-25",
      pointTwo: "Redeemable only as Vouchers",
    },
    {
      label: "New Points",
      value: Number(getPointsData?.newPoints),
      prefix: "",
      pointOne: "Earned on/after 1-Nov-25",
      pointTwo: "Redeemable via UPI and Vouchers",
      pointThree: `T.D.S : ${getPointsData?.tds} pts`,
      pointFour: `Total Earning So Far: ${getPointsData?.newTotalPoints} pts`,
    },
    // {
    //   label: "Opening 'Locked' Rewards on 30 - Nov - 22",
    //   value: dashboardData?.lockedPoint,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Earned 'Unlocked' Rewards w.e.f. 01 - Dec - 22",
    //   value: dashboardData?.earnedPointCurentMonth,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "TDS u/ s 194R w.e.f. 01 - Dec - 22",
    //   value: dashboardData?.onTdsPct,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Redeemed w.e.f. 01 - Dec - 22",
    //   value: dashboardData?.redeemed,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Total 'Locked + Unlocked' Rewards Balance",
    //   value: dashboardData?.totalLockedULocked,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Redeemable in current month",
    //   value: dashboardData?.reedeemableCurentMonth,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Rewards Earned in Current Month (Including TDS)",
    //   value: dashboardData?.cuurentMonthTds,
    //   prefix: "Rs. ",
    // },
  ];

  return (
    <>
      <Navbar />
      <section className="page-content--bge55">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 left-menu">
              <div className="item">
                <p className="top-title">TOTAL EARNED INCENTIVE:</p>
                <ul className="retailer-side-list">
                  {summaryItems.map((item, index) => {
                    const detailPoints = [
                      item.pointOne,
                      item.pointTwo,
                      item.pointThree,
                      item.pointFour,
                    ].filter(Boolean);

                    return (
                      <li key={item.label} className="retailer-side-list-item">
                        <div className="retailer-side-header">
                          <div
                            className="retailer-side-copy"
                            style={{ fontWeight: "bolder" }}
                          >
                            <p>{item.label}</p>
                          </div>
                          <div className="retailer-side-value-wrap">
                            <span className="button-style2">
                              {item.prefix}
                              {item.value ?? 0}
                            </span>
                          </div>
                        </div>
                        {detailPoints.length > 0 ? (
                          <ul
                            className="retailer-side-points"
                            style={{ fontWeight: "lighter" }}
                          >
                            {detailPoints.map((point) => (
                              <li key={point} className="retailer-side-point">
                                {point}
                              </li>
                            ))}
                          </ul>
                        ) : null}
                        {index !== summaryItems.length - 1 ? (
                          <hr className="separatehr" />
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="col-md-9">
              <div className="row">
                <div className="col-md-12">
                  <h3 className="head1">Dashboard</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/Purchase_History">
                      <span>
                        <i className="fa fa-file-text-o"></i>
                      </span>
                      <p>Purchase History</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/RewardPoints">
                      <span>
                        <i className="fa fa-star"></i>
                      </span>
                      <p>Points Bifurcation</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/redeemption">
                      <span>
                        <i className="fa fa-money"></i>
                      </span>
                      <p>Redeemption</p>
                    </Link>
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link
                      //to="/redeemption"
                      onClick={handleRedemptionClick}
                    >
                      <span>
                        <i className="fa fa-money"></i>
                      </span>
                      <p>Redeemption</p>
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link 
                      to="/upi_redeemption" 
                      onClick={handleUpiRedemptionClick}
                    >
                      <span>
                        <i className="fa fa-money"></i>
                      </span>
                      <p>UPI Redeemption</p>
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to={evgurl} target="_blank">
                      <span>
                        <i className="fa fa-trophy"></i>
                      </span>
                      <p>Redeem Electronic Gift Voucher</p>
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/VoucherRedemptionHistory">
                      <span>
                        <i className="fa fa-history"></i>
                      </span>
                      <p>Discount Voucher Redemption History</p>
                    </Link>
                  </div>
                </div> */}

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/redemption_history">
                      <span>
                        <i className="fa fa-history"></i>
                      </span>
                      <p>Redemption History</p>
                    </Link>
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/order_indent">
                      <span>
                        <i className="fa fa-shopping-cart"></i>
                      </span>
                      <p>Order Indent</p>
                    </Link>
                  </div>
                </div> */}
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/videos">
                      <span>
                        <i className="fa fa-video-camera"></i>
                      </span>
                      <p>Videos</p>
                    </Link>
                  </div>
                </div>
                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/PlumberList">
                      <span>
                        <i className="fa fa-user"></i>
                      </span>
                      <p>Manage Plumber</p>
                    </Link>
                  </div>
                </div> */}

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link
                      to="/scheme_offer"
                      onClick={handleSchemeClick}
                      title="Schemes &amp; Promotions"
                    >
                      Schemes &amp; Promotions
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/reward_point_matrix" onClick={handleRewardMatrixClick}>
                      <span>
                        <i className="fa fa-gift"></i>
                      </span>
                      <p>Reward Matrix</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/feedback_support">
                      <span>
                        <i className="fa fa-phone-square"></i>
                      </span>
                      <p>Feedback / Support</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    {/* <Link to="/faq"> */}
                    <Link to={faqsurl} target="_blank">
                      <span>
                        <i className="fa fa-question-circle"></i>
                      </span>
                      <p>FAQs</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    {/* <Link to="/tnc"> */}
                    <Link to={tncurl} target="_blank">
                      <span>
                        <i className="fa fa-file"></i>
                      </span>
                      <p>Terms &amp; Conditions</p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/makewish">
                      <span>
                        <i className="fa fa-magic"></i>
                      </span>
                      <p>Make a Wish</p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/make_a_wish_history">
                      <span>
                        <i className="fa fa-circle-o-notch"></i>
                      </span>
                      <p>Make a Wish History</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/product_wise_summary">
                      <span>
                        <i className="fa fa-line-chart"></i>
                      </span>
                      <p>Product Wise Summary</p>
                    </Link>
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/upload_shop_image_rate">
                      <span>
                        <i className="fa fa-picture-o"></i>
                      </span>
                      <p>Display Incentive</p>
                    </Link>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Popup Modal */}
      {showPopup && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>Coming Soon</h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              UPI Redemption feature is coming soon. Please check back later.
            </p>
            <button
              onClick={closePopup}
              style={{
                backgroundColor: "rgb(82, 184, 184)",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {showRedemptionPopup && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>Coming Soon</h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Redemption feature is coming soon. Please check back later.
            </p>
            <button
              onClick={closeRedemptionPopup}
              style={{
                backgroundColor: "rgb(82, 184, 184)",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}


      {showRewardMatrixPopup && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>Coming Soon</h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Reward Matrix feature is coming soon. Please check back later.
            </p>
            <button
              onClick={closeRewardMatrixPopup}
              style={{
                backgroundColor: "rgb(82, 184, 184)",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {showSchemePopup && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>Coming Soon</h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Schemes & Promotions feature is coming soon. Please check back later.
            </p>
            <button
              onClick={closeSchemePopup}
              style={{
                backgroundColor: "rgb(82, 184, 184)",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
      {/* TDS Consent Modal Overlay (Clean & Scrollbar-Free Landscape View) */}
      {showTdsModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            className="tds-modal-card"
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              padding: "22px 24px 20px 24px",
              maxWidth: "780px",
              width: "100%",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              fontFamily: "'Poppins', sans-serif, system-ui",
              maxHeight: "94vh",
              overflowY: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {/* Header Shield Icon */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "#e8f2fe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#2563eb"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <rect
                    x="9"
                    y="11"
                    width="6"
                    height="5"
                    rx="1"
                    stroke="#2563eb"
                    strokeWidth="1.6"
                  />
                  <path d="M10 11V9a2 2 0 0 1 4 0v2" />
                </svg>
              </div>
            </div>

            {/* Title & Description */}
            <h3
              style={{
                color: "#0f2d6b",
                fontSize: "20px",
                fontWeight: "700",
                textAlign: "center",
                margin: "0 0 6px 0",
              }}
            >
              TDS Consent
            </h3>
            <p
              style={{
                color: "#334155",
                fontSize: "12.5px",
                lineHeight: "1.4",
                textAlign: "center",
                margin: "0 0 16px 0",
                fontWeight: "400",
              }}
            >
              As per Section 393(1) [Table: Sl. No. 8(iv)] of the Income Tax
              Act, 1961, TDS will be deducted on your benefits/claims before
              credit.
            </p>

            {/* Options Grid (Side by side on desktop, stacked on mobile) */}
            <div className="tds-options-grid" style={{ marginBottom: "14px" }}>
              {/* Option 1: YES */}
              <div
                onClick={() => setTdsSelectedOption("YES")}
                style={{
                  border:
                    tdsSelectedOption === "YES"
                      ? "2px solid #0066ff"
                      : "1px solid #e2e8f0",
                  borderRadius: "16px",
                  padding: "14px",
                  backgroundColor:
                    tdsSelectedOption === "YES" ? "#ffffff" : "#f8fafc",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <div style={{ marginTop: "2px", flexShrink: 0 }}>
                    <div
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        border:
                          tdsSelectedOption === "YES"
                            ? "5px solid #0066ff"
                            : "2px solid #94a3b8",
                        backgroundColor: "#ffffff",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "8px",
                      backgroundColor: "#e0f2fe",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#0284c7"
                      strokeWidth="2"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <polyline points="9 15 11 17 15 13" />
                    </svg>
                  </div>
                  <div style={{ flex: 1, textAlign: "left" }}>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "12px",
                        color: "#1e293b",
                        lineHeight: "1.4",
                      }}
                    >
                      <strong style={{ color: "#0066ff" }}>Yes</strong>, I am
                      willing to share my PAN details, and I hereby authorize
                      Sintex to deduct TDS under Section 393(1) [Table: Sl. No.
                      8(iv)] at 10%. Form 131 (formerly known as Form 16A) will
                      be issued.
                    </p>
                  </div>
                </div>

                <div style={{ marginTop: "10px", textAlign: "left" }}>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      padding: "3px 10px",
                      backgroundColor: "#f0f7ff",
                      borderRadius: "20px",
                      border: "1px solid #dbeafe",
                    }}
                  >
                    <span style={{ fontSize: "11px" }}>🏷️</span>
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "700",
                        color: "#0066cc",
                      }}
                    >
                      TDS Rate: 10%
                    </span>
                  </div>
                </div>
              </div>

              {/* Option 2: NO */}
              <div
                onClick={() => setTdsSelectedOption("NO")}
                style={{
                  border:
                    tdsSelectedOption === "NO"
                      ? "2px solid #ef4444"
                      : "1px solid #fecdd3",
                  borderRadius: "16px",
                  padding: "14px",
                  backgroundColor:
                    tdsSelectedOption === "NO" ? "#ffffff" : "#fff5f5",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <div style={{ marginTop: "2px", flexShrink: 0 }}>
                    <div
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        border:
                          tdsSelectedOption === "NO"
                            ? "5px solid #ef4444"
                            : "2px solid #94a3b8",
                        backgroundColor: "#ffffff",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "8px",
                      backgroundColor: "#ffe4e6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#e11d48"
                      strokeWidth="2"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="9" y1="13" x2="15" y2="17" />
                      <line x1="15" y1="13" x2="9" y2="17" />
                    </svg>
                  </div>
                  <div style={{ flex: 1, textAlign: "left" }}>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "12px",
                        color: "#1e293b",
                        lineHeight: "1.4",
                      }}
                    >
                      <strong style={{ color: "#dc2626" }}>No</strong>, I am not
                      willing to share my PAN details / I do not have PAN / My
                      PAN is inoperative and authorize Sintex to deduct TDS at
                      20%. Form 131 (formerly known as Form 16A) will be issued.
                    </p>
                  </div>
                </div>

                <div style={{ marginTop: "10px", textAlign: "left" }}>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      padding: "3px 10px",
                      backgroundColor: "#fff1f2",
                      borderRadius: "20px",
                      border: "1px solid #fecdd3",
                    }}
                  >
                    <span style={{ fontSize: "11px" }}>🏷️</span>
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "700",
                        color: "#dc2626",
                      }}
                    >
                      TDS Rate: 20%
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Mandatory Info Box */}
            <div
              style={{
                backgroundColor: "#fffbeb",
                border: "1px solid #fef08a",
                borderRadius: "14px",
                padding: "10px 14px",
                marginBottom: "14px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  border: "1.8px solid #d97706",
                  color: "#d97706",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "11px",
                  flexShrink: 0,
                }}
              >
                i
              </div>
              <p
                style={{
                  margin: 0,
                  fontSize: "12px",
                  color: "#78350f",
                  lineHeight: "1.35",
                  fontWeight: "400",
                }}
              >
                This consent is mandatory to continue using the Website. You will not
                be able to use any features without providing your consent.
              </p>
            </div>

            {/* Submit Button */}
            <button
              onClick={handleTdsSubmit}
              disabled={submittingTds}
              style={{
                width: "100%",
                backgroundColor: "#0066ff",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "12px 20px",
                fontSize: "15px",
                fontWeight: "700",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                boxShadow: "0 4px 14px rgba(0, 102, 255, 0.35)",
                transition: "background-color 0.2s ease",
              }}
            >
              {submittingTds ? (
                <span>
                  <i className="fa fa-spinner fa-spin"></i> Submitting...
                </span>
              ) : (
                <>
                  <span>Confirm & Continue</span>
                  <span style={{ fontSize: "16px" }}>→</span>
                </>
              )}
            </button>
          </div>
        </div>
      )}

      <style>{`
        .tds-modal-card {
          scrollbar-width: none !important;
          -ms-overflow-style: none !important;
        }

        .tds-modal-card::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        @media (min-width: 700px) {
          .tds-options-grid {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 16px !important;
          }
        }

        @media (max-width: 699px) {
          .tds-options-grid {
            display: flex !important;
            flex-direction: column !important;
            gap: 12px !important;
          }
        }

        .retailer-side-list {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .retailer-side-list-item {
          margin-bottom: 0;
          padding: 18px 0 0;
        }

        .retailer-side-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .retailer-side-copy p {
          margin: 0;
          line-height: 1.45;
        }

        .retailer-side-points {
          margin: 12px 0 0;
          padding-left: 22px;
          list-style-type: disc;
          list-style-position: outside;
        }

        .retailer-side-point {
          display: list-item;
          font-weight: 300;
          line-height: 1.5;
        }

        .retailer-side-point::marker {
          color: #ffffff;
        }

        .retailer-side-point + .retailer-side-point {
          margin-top: 8px;
        }

        .retailer-side-value-wrap {
          display: flex;
          justify-content: flex-end;
          flex-shrink: 0;
          margin-top: 0;
        }
      `}</style>
    </>
  );
}



